'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagSsAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V5.33333H28V0Z", fill: "#262626" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M28.0002 6.66667H0.00016276V13.3333H28.0002V6.66667Z",
          fill: "#E22A32"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M28 5.33333H0L0.00016276 6.66667H28.0002L28 5.33333Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M28.0002 14.6667H0.00016276L0 20H28L28.0002 14.6667Z",
          fill: "#2CA244"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M28.0002 13.3333H0.00016276V14.6667H28.0002V13.3333Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 0L13.3333 10L0 20V0Z",
          fill: "#185AC6"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.11524 10.6493L4.20386 12.3563L3.93126 10.4405L2.0262 10.1012L3.76394 9.24999L3.49793 7.33333L4.84451 8.72297L6.58516 7.8777L5.67965 9.58779L7.02145 10.982L5.11524 10.6493Z",
          fill: "#FDE14A"
        }
      )
    ]
  }
);
const VpFlagSsAsset = forwardRef(FlagSsAsset);

export { VpFlagSsAsset as default };
